"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Buffer = void 0;
var buffer_1 = require("buffer");
Object.defineProperty(exports, "Buffer", { enumerable: true, get: function () { return buffer_1.Buffer; } });
if (typeof window !== 'undefined') {
    window.Buffer = window.Buffer || buffer_1.Buffer;
    window.global = window;
}
